import Vue from 'vue'

export default {
  'data': function () {
    return {
      data: {}
    }
  },
  'created': function () {
    Vue.http.get('auth/detail/17').then((resp) => {
      this.data = resp.body
    })
  },
  'methods': {

  }
}



// WEBPACK FOOTER //
// ./src/component/area-riservata/area-riservata-contact/area-riservata-contact.js